import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Check } from 'lucide-react'

import { Button } from '../../ui/button'
import { Checkbox } from '../../ui/checkbox'
import { Input } from '../../ui/input'
import { Popover, PopoverContent, PopoverTrigger } from '../../ui/popover'
import { Badge } from '../../ui/badge'

function FacilityMultiSelect({ facilities, value, onChange }) {
  const [search, setSearch] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  const safeFacilities = facilities || []
  const safeValue = value || []

  const selectedFacilities = safeFacilities.filter((f) => safeValue.includes(f.id))
  const filteredFacilities = safeFacilities.filter((f) => f.name.toLowerCase().includes(search.toLowerCase()))

  function handleToggle(facilityId) {
    if (safeValue.includes(facilityId)) {
      onChange(safeValue.filter((id) => id !== facilityId))
    } else {
      onChange([...safeValue, facilityId])
    }
  }

  function handleClear() {
    onChange([])
  }

  return (
    <div className="space-y-2">
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <Button variant="outline" className="w-full justify-start h-auto min-h-[40px]">
            {selectedFacilities.length === 0 ? (
              <span className="text-gray-500">Select facilities...</span>
            ) : (
              <div className="flex flex-wrap gap-1">
                {selectedFacilities.map((facility) => (
                  <Badge key={facility.id} variant="secondary" className="text-xs">
                    {facility.name}
                  </Badge>
                ))}
              </div>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-[400px] p-0" align="start">
          <div className="p-2 border-b">
            <Input
              placeholder="Search facilities..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="h-9"
            />
          </div>
          <div className="max-h-[300px] overflow-y-auto p-2">
            {filteredFacilities.length === 0 ? (
              <div className="text-center py-4 text-gray-500 text-sm">No facilities found</div>
            ) : (
              <div className="space-y-1">
                {filteredFacilities.map((facility) => (
                  <div
                    key={facility.id}
                    className="flex items-center space-x-2 p-2 rounded hover:bg-gray-100 cursor-pointer"
                    onClick={() => handleToggle(facility.id)}
                  >
                    <Checkbox checked={safeValue.includes(facility.id)} />
                    <span className="flex-1 text-sm">{facility.name}</span>
                    {safeValue.includes(facility.id) && <Check className="h-4 w-4 text-green-600" />}
                  </div>
                ))}
              </div>
            )}
          </div>
          {selectedFacilities.length > 0 && (
            <div className="p-2 border-t flex justify-between items-center">
              <span className="text-sm text-gray-600">{selectedFacilities.length} selected</span>
              <Button variant="ghost" size="sm" onClick={handleClear} className="h-8 text-xs">
                Clear All
              </Button>
            </div>
          )}
        </PopoverContent>
      </Popover>
    </div>
  )
}

FacilityMultiSelect.propTypes = {
  facilities: PropTypes.array.isRequired,
  value: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired
}

export default FacilityMultiSelect
